"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersistenceContext = void 0;
const React = require("react");
/**
 * Context exposing universal local storage methods.
 * Needed to be able to share across multiple environment with different implementations (e.g. web vs mobile native)
 */
exports.PersistenceContext = React.createContext({
    getItem: undefined,
    setItem: undefined,
    removeItem: undefined
});
//# sourceMappingURL=index.js.map